import React from 'react'
import { graphql } from 'gatsby'
import {
  ContentfulComponentHeader,
  ContentfulComponentLink,
} from 'types/contentful'
import * as styles from './header.module.css'

type HeaderProps = {
  header: ContentfulComponentHeader
}

const Menu = ({ links }: { links: ContentfulComponentLink[] }) => {
  return (
    <ul className={styles.menu}>
      {links.map((link) => (
        <li key={link.contentful_id} className={styles.menuItem}>
          <a href={link.url} className={styles.menuItemLink}>
            {link.text}
          </a>
        </li>
      ))}
    </ul>
  )
}

const Header = ({ header }: HeaderProps) => {
  const { links } = header

  return (
    <header
      className={styles.header}
      style={{
        backgroundColor: `${header?.backgroundColorHex}`,
      }}
    >
      <div className={styles.navbar}>
        <nav role="navigation" className={styles.mainNav} aria-label="Main">
          {header?.logo && (
            <img
              className={styles.logoImage}
              src={header.logo.image.file.url}
              alt={header.logo.image.title}
            />
          )}
        </nav>

        {links?.length > 0 && (
          <>
            <nav className={styles.desktopMenu}>
              <Menu links={links} />
            </nav>
            <div className={styles.mobileMenu}>
              <input
                type="checkbox"
                id="hamburger-input"
                className={styles.mobileMenuControl}
              />
              <label
                className={styles.mobileMenuLabel}
                htmlFor="hamburger-input"
              ></label>

              <nav className={styles.mobileMenuNav}>
                <Menu links={links} />
              </nav>
            </div>
          </>
        )}
      </div>
    </header>
  )
}

export default Header

export const query = graphql`
  fragment HeaderFields on ContentfulComponentHeader {
    backgroundColorHex
    logo {
      image {
        title
        file {
          url
        }
      }
    }
    links {
      contentful_id
      text
      url
    }
  }
`
